import * as React from 'react'

function Logo(props) {
    return (
        <img className="lazy loaded" 
        onclick="window.location.href='https://station-frankfurt.de'"
        style={{ width: 150, height: 53}}
        src="https://station-frankfurt.de/wp-content/uploads/2018/12/station_fra.png" 
        data-src="https://station-frankfurt.de/wp-content/uploads/2018/12/station_fra.png" alt="Station" data-was-processed="true"/>
    )
}

export default Logo
